//WMS - 仓库管理api
import {ServerDistApi, ServerNoDistApi} from '@/group-cloud/network/ServerBizApi';

//配置下拉框值集
export const All_Sel_Option = 'all';
//库存状态
export const Mod_StockStatus_Types = {
    ZERO: 0,  //待确认
    ONE: 1,   //已确认
    TWO: 2,   //已入库
    THREE: 3,  //异常
    FOUR: 4,  //已取消
}

export const Mod_StockStatus_Options = [
    { id: All_Sel_Option, label: '全部' },
    { id: Mod_StockStatus_Types.ZERO, label: '待确认' },
    { id: Mod_StockStatus_Types.ONE, label: '已确认' },
    { id: Mod_StockStatus_Types.TWO, label: '已入库' },
    { id: Mod_StockStatus_Types.FOUR, label: '已取消'},
    { id: Mod_StockStatus_Types.THREE, label: '异常' },
];
//仓库类型
export const Mod_Warehouse_Types = {
    MAIN: 'MAIN',  //主仓
    DIST:  'DIST',   //分仓 
    OTHER: 'OTHER'
}
export const Mod_Warehouse_Types_Options = [
    {id: All_Sel_Option, label: '全部'},       
    {id: Mod_Warehouse_Types.MAIN, label: '总仓'}, //主仓 
    {id: Mod_Warehouse_Types.DIST, label: '仓库'},  //分仓
    {id: Mod_Warehouse_Types.OTHER, label: '仓位'}  //分仓
]
export class WmsWarehouseApi {

    constructor() {
    }
    protected static groupUrl = '/wms/ws';
    
    //获取仓库链接:分页
    public static async getWarehouseList(data) {
        let uri = this.groupUrl + '/pageList';
        return await ServerDistApi.send(uri, data);
    }

    //获取仓库链接:不分页
    public static async getWarehouseAll(data) {
        let uri = this.groupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }
    //保存仓库
    public static async saveWarehouse(data) {
        let uri = this.groupUrl + '/save';
        return await ServerDistApi.send(uri, data);
    }

    //获取单个仓库数据
    public static async oneWarehouse(data) {
        let uri = this.groupUrl + '/get';
        return await ServerDistApi.get(uri, data);
    }

    //删除仓库
    public static async deleteWarehouse(data){
        let uri = this.groupUrl + '/delete';
        return await ServerDistApi.get(uri, data);
    }

    //仓位添加
    public static async saveLoc(data) {
        let uri = this.groupUrl + '/loc/save';
        return await ServerDistApi.send(uri, data);
    }
    
    //获取仓位
    public static async getLocList(data) {
        let uri = this.groupUrl + '/loc/list';
        return await ServerDistApi.send(uri, data);
    }
    
    //仓位添加
    public static async getLocAll(data) {
        let uri = this.groupUrl + '/loc/all';
        return await ServerDistApi.send(uri, data);
    }
    //获取一个仓位信息
    public static async oneLocList(data) {
        let uri = this.groupUrl + '/loc/get';
        return await ServerDistApi.get(uri, data);
    }
    //获取主体
    public static async getAllMainBody(data){
        let url = '/main/account/configuration/selectList';
        return await ServerNoDistApi.get(url, data);
    }
}


